import axios from "axios";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

const endpoint = process.env.NEXT_PUBLIC_ASSETS_ENDPOINT + "/Truck";

export async function fetchReadyForReview() {
  const response = await axios.get(`${endpoint}/fetchReadyForReview`);

  return response.data;
}

export async function fetchRecent() {
  const response = await axios.get(`${endpoint}/fetchRecent`);

  return response.data;
}

export async function getDetails(stockNumber) {
  let responseData = null;

  try {
    const response = await axios.get(`${endpoint}/${stockNumber}`);

    responseData = response.data;
  } catch (err) {
    responseData = err.response;
  }

  return responseData;
}

export async function getMultiple(searchTerm) {
  let response = await axios.get(`${endpoint}/fetchMultiple?searchTerm=${searchTerm}`);
  return response.data;
}

export async function updateDetails(stockNumber, isWholesale) {
  await axios.put(`${endpoint}/${stockNumber}`, { stockNumber, isWholesale });
}

export async function deleteImages(stockNumber, assetIds) {
  const response = await axios.delete(`${endpoint}/${stockNumber}/assets`, {
    params: { assetIds: assetIds.join(",") },
  });

  return response;
}

export async function generateFeaturedImage(stockNumber) {
  await axios.post(`${endpoint}/${stockNumber}/assets/generate`);
}

export async function downloadImages(stockNumber, assetIds) {
  const timeStamp = dayjs().format("YY-MM-DD_HH-mm-ss");

  const response = await axios.get(`${endpoint}/${stockNumber}/assets/download`, {
    responseType: "blob",
    params: {
      assetIds: assetIds.join(","),
    },
  });

  saveAs(response.data, `${stockNumber}-${timeStamp}.zip`);

  return "successfully downloaded";
}

export async function approveImage(stockNumber, assetId) {
  const response = await axios.get(
    `${endpoint}/${stockNumber}/assets/${assetId}/markAsReviewed`
  );

  return response;
}

export async function showImage(stockNumber, assetId) {
  const response = await axios.get(`${endpoint}/${stockNumber}/assets/${assetId}`);

  return response.data;
}

export async function updateImageDetails(stockNumber, assetId, assetDetails) {
  const response = await axios.put(`${endpoint}/${stockNumber}/assets/${assetId}`, {
    ...assetDetails,
  });

  return response;
}

export async function bulkUpdateImageDetails(stockNumber, assetDetails) {
  const response = await axios.put(`${endpoint}/${stockNumber}/assets`, assetDetails);

  return response;
}

export async function deleteImage(stockNumber, assetId) {
  const response = await axios.delete(`${endpoint}/${stockNumber}/assets/${assetId}`);

  return response.data;
}

export async function reorderImages(stockNumber, assetIds) {
  const response = await axios.put(`${endpoint}/${stockNumber}/assets/sort`, assetIds);

  return response;
}

export async function createTruckRecord(assetDetails) {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT}/Truck`,
    {
      ...assetDetails,
    }
  );

  return response;
}

export async function getPhotoContainers() {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT}/Scaffolding`
  );

  return response?.data?.photos;
}

export async function getBranches() {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT}/Branch`
  );

  return response?.data;
}

export async function syncTruckToWebsite(stockNumber) {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT}/Truck/${stockNumber}/sync`
  );

  return response;
}

export async function convertToAppraisal(stockNumber) {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT}/Truck/${stockNumber}/convertToAppraisal`
  );

  return response;
}
